/* eslint-disable */

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { CCard, CCardBod, CCardBody, CCardHeader } from '@coreui/react';
import { Button, Form, Input, InputNumber, Modal, Pagination, Select, Spin, Switch, Table, Upload, message, notification } from 'antd';
import Jwt_decrypt from "common/Jwt_decrypt";
import axiosCall from "common/axios_call";
import CategoryNav from 'examples/Navbars/CategoryNav';
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

const EditCategory = () => {
    const navigate = useNavigate()
    const [form] = Form.useForm();
    const [imageUrl, setImageUrl] = useState(null);
    const [imageToSend, setImageToSend] = useState(null);
    const [loading, setLoading] = useState(false);
    const [categoryBox, setCategoryBox] = useState({});
    const [categoryErrorMessage, setCategoryErrorMessage] = useState('');
    const jwt = localStorage.konnect_admin_token;

    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

    const { TextArea } = Input;

    const openNotificationWithIcon = (type, message) => {
        notification[type]({ message: '', placement: 'bottomRight', description: message, });
    };

    if (!jwt) {
        openNotificationWithIcon('error', 'Unauthorized')
        return navigate('/')
    }

    const token = Jwt_decrypt({ token: localStorage.konnect_admin_token });
    let cat_id = window.location.href.split('/')[window.location.href.split('/').length - 1];
    useEffect(() => {
        axiosCall(`/category/${cat_id}`, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
            setCategoryBox(res.data.data)
            setImageUrl(res.data.data.category_image)
        }).catch(err => {
            openNotificationWithIcon('error', err.response.data.message)
        })
    }, [])

    const { Option } = Select;

    const updateCategory = (values) => {
        axiosCall.patch(`/category/${cat_id}`, { category_code: values.category_code, category_name: values.category_name, category_image: values.category_image, description: values.description, display_status: values.display_status, discount_rate: `${values.discount_rate}`, }, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
            openNotificationWithIcon('success', res.data.message)
            navigate('/categories')
        }).catch(err => {
            openNotificationWithIcon('error', err.response.data.message)
        })
    }

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.addEventListener('load', () => callback(reader.result));
    }
    const handleChange = info => {
        getBase64(info.file.originFileObj, imageUrl =>
            setImageUrl(imageUrl),
            setLoading(false),
        );
        const reader = new FileReader();

        reader.readAsDataURL(info.file.originFileObj);
        reader.addEventListener('load', () => {
            setImageToSend(reader.result);
            form.setFieldsValue({ category_image: reader.result });
        });
    }
    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    return (
        <DashboardLayout>
            <CategoryNav title="Edit Category" breadroute="editcategory" />
            <MDBox pt={6} pb={6}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" >
                                <MDTypography variant="h6" color="white">
                                    Category
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={3} pb={3} px={2}>
                                {categoryBox.category_name ?
                                    <React.Fragment>
                                        <CCard>
                                            <CCardHeader>
                                                <div className="grid-flex">
                                                    Edit Category
                                                </div>
                                            </CCardHeader>
                                            <CCardBody>
                                                {
                                                    categoryErrorMessage.length ? <p className="error-message">{categoryErrorMessage}</p> : ''
                                                }
                                                <Form form={form} onFinish={updateCategory} initialValues={{ category_name: categoryBox.category_name, category_code: categoryBox.category_code, display_status: categoryBox.display_status, discount_rate: categoryBox.discount_rate, description: categoryBox.description, }} layout="vertical">
                                                    <Form.Item name="category_image" label="Category Image" >
                                                        <Upload name="avatar" listType="picture-card" className="avatar-uploader" showUploadList={false} multiple={false} onChange={handleChange} >
                                                            {imageUrl ? <img src={imageUrl} alt="avatar" className="adminCourseUpload" /> : uploadButton}
                                                        </Upload>
                                                    </Form.Item>
                                                    <Form.Item name="category_name" label="Category Name" >
                                                        <Input placeholder="Category Name" />
                                                    </Form.Item>
                                                    <Form.Item name="category_code" label="Category Code" >
                                                        <Input placeholder="Category Code" />
                                                    </Form.Item>
                                                    <Form.Item name="discount_rate" label="Discount Rate ( % )" >
                                                        <InputNumber style={{ width: "100%" }} min={0} max={100} placeholder="Discount Rate" />
                                                    </Form.Item>
                                                    <Form.Item name="display_status" label="Display Status" >
                                                        <Select>
                                                            <Select.Option value={true}>Activate</Select.Option>
                                                            <Select.Option value={false}>De-activate</Select.Option>
                                                        </Select>
                                                    </Form.Item>
                                                    <Form.Item name="description" label="Category Description" >
                                                        <TextArea rows={4} placeholder="Category Description" />
                                                    </Form.Item>
                                                    <Form.Item>
                                                        <Button htmlType="submit" type="primary">Submit</Button>
                                                    </Form.Item>
                                                </Form>
                                            </CCardBody>
                                        </CCard>
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <CCard>
                                            <CCardHeader>
                                                <div className="grid-flex">
                                                    Edit Category
                                                </div>
                                            </CCardHeader>
                                            <CCardBody>
                                                <Spin indicator={antIcon} />
                                            </CCardBody>
                                        </CCard>
                                    </React.Fragment>
                                }
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout >
    )
}

export default EditCategory;